import SubscriptionsTable from 'src/features/subscriptions/components/tables/SubscriptionsTable';
import { useIntl } from 'react-intl';
import React from 'react';
import { subscriptionsMessages } from 'src/features/subscriptions/utils/messages';
import { useTitleStore } from 'src/stores/useTitleStore';

const SubscriptionLayout = () => {
    const { setTitle, removeTitle } = useTitleStore();
    const { formatMessage } = useIntl();

    React.useEffect(() => {
        setTitle(formatMessage(subscriptionsMessages.subscriptions));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <SubscriptionsTable />;
};

export default SubscriptionLayout;
